import { render, staticRenderFns } from "./page-messages.vue?vue&type=template&id=ca12c3e4&"
import script from "./page-messages.vue?vue&type=script&lang=js&"
export * from "./page-messages.vue?vue&type=script&lang=js&"
import style0 from "./page-messages.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LineLink: require('/opt/build/repo/storefront/components/atoms/Link/LineLink.vue').default,SlideDownTransition: require('/opt/build/repo/storefront/components/atoms/Transition/SlideDownTransition.vue').default})
